import React from 'react';
import classNames from 'classnames';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import css from './SharedComponents.module.css';
import { PrimaryButtonInline } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { closeListing, perksListingsSelector } from '../ListingPage.duck';
import { FormattedMessage } from 'react-intl';
import { isArrayLength } from '../../../util/genericHelpers';
import { useListingPageContext } from '../context/ListingPageContext';
import ListingPageActionButtons from '../ListingPageActionButtons';
import { EDIT, PERKS } from '../../../util/constants';
import { createResourceLocatorString } from '../../../util/routes';
import { createSlug } from '../../../util/urlHelpers';

function Step({
  listing,
  isOwnListing,
  dispatch,
  history,
  routeConfiguration,
  profileImageIcon,
  isCurrentUserLinkedToListing,
}) {
  const { title, publicData = {} } = listing?.attributes || {};
  const { perkProvided, tasks } = publicData || {};
  const handleEdit = () => {
    history.push({
      pathname: createResourceLocatorString(
        'EditPerksPostPage',
        routeConfiguration,
        { id: listing?.id?.uuid, slug: createSlug(title), type: EDIT },
        {}
      ),
      state: { isEditPerksPostPage: true },
    });
  };
  const handleDelete = async () => {
    await dispatch(closeListing(PERKS, listing?.id?.uuid));
  };
  return (
    <div className={classNames(css.couponBlock, css.perkCouponBlock)}>
      <div className={css.blockTopInfo}>
        <div className={css.offerNameSec}>
          <div className={css.offerImgSec}>
            <img src={profileImageIcon} alt="img" />
          </div>
          <div className={css.offerInfoSec}>
            <h3>{title}</h3>
          </div>
        </div>

        {perkProvided && (
          <div className={css.pills}>
            <span className={css.pill}>{perkProvided}</span>
          </div>
        )}
        {tasks && (
          <div className={css.jobDescription}>
            <p className={css.description}>{tasks}</p>
          </div>
        )}
      </div>
      <div className={css.blockBottomInfo} style={{ justifyContent: 'center' }}>
        {isCurrentUserLinkedToListing && (
          <div className={css.blockInfoLeft}>
            <PrimaryButtonInline className={css.applyBtn}>
              <FormattedMessage id="RenderPerks.applyNow" />
            </PrimaryButtonInline>
          </div>
        )}
      </div>
      {isOwnListing && (
        <ListingPageActionButtons
          listingId={listing?.id?.uuid}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      )}
    </div>
  );
}

function RenderPerks({ profileImageIcon, isCurrentUserLinkedToListing }) {
  const perksListings = useSelector(perksListingsSelector);
  const { isOwnListing, history, routeConfiguration } = useListingPageContext();
  const dispatch = useDispatch();

  if (!isArrayLength(perksListings)) {
    return <></>;
  }
  return (
    <>
      {isArrayLength(perksListings) && (
        <div className={classNames(css.talentOptions, css.brandPostings)}>
          <div className={css.contentWidth}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>
                  <FormattedMessage id="RenderPerks.title" />
                </h2>
              </div>
            </div>
            <div className={css.sectionContent}>
              <div className={css.brandCouponSec}>
                <Slider
                  {...{
                    ...sliderSettings,
                  }}
                >
                  {isArrayLength(perksListings) &&
                    perksListings.map((listing, index) => (
                      <Step
                        key={listing?.id?.uuid}
                        listing={listing}
                        isOwnListing={isOwnListing}
                        dispatch={dispatch}
                        history={history}
                        profileImageIcon={profileImageIcon}
                        routeConfiguration={routeConfiguration}
                        isCurrentUserLinkedToListing={isCurrentUserLinkedToListing}
                      />
                    ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
};

RenderPerks.defaultProps = {
  sliderSettings,
};

export default RenderPerks;
